import { useEffect, useState } from "react";
import useReveal from "../shared/useReveal";
import step1 from "../../assets/process/step1.png";
import step2 from "../../assets/process/step2.png";
import step3 from "../../assets/process/step3.png";
import "./StepsSection.css";
import "./HomeSections.css";

const STEPS = [
  {
    n: "01",
    title: "Book a free call",
    desc: "A 20-minute discovery call with an expert — your goals, your risk comfort, your questions. No sales pitch.",
    img: step1,
    alt: "Discovery call and goal planning",
  },
  {
    n: "02",
    title: "Get your written plan",
    desc: "A goal-based plan with exact asset allocation, product recommendations and costs — in writing, before you invest a rupee.",
    img: step2,
    alt: "Written investment plan and asset allocation",
  },
  {
    n: "03",
    title: "Invest & review quarterly",
    desc: "Paperless onboarding, disciplined execution, and a formal review every quarter to keep you on track.",
    img: step3,
    alt: "Portfolio growth and quarterly reviews",
  },
];

export default function StepsSection() {
  const ref = useReveal({ threshold: 0.2 });
  const [active, setActive] = useState(0);
  const [playing, setPlaying] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return undefined;
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      return undefined;
    }

    const obs = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) setPlaying(true);
      },
      { threshold: 0.35 }
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, [ref]);

  useEffect(() => {
    if (!playing) return undefined;
    const id = window.setInterval(() => {
      setActive((i) => (i + 1) % STEPS.length);
    }, 2800);
    return () => window.clearInterval(id);
  }, [playing]);

  return (
    <section className="section home-steps-section" id="how-it-works">
      <div className="container" ref={ref}>
        <div className="home-section-head section-head pm-reveal">
          <span className="kicker">Getting Started</span>
          <h2>Three steps. Zero paperwork stress.</h2>
        </div>

        <div
          className="home-steps-progress"
          role="tablist"
          aria-label="Getting started steps"
        >
          {STEPS.map((step, i) => (
            <button
              key={step.n}
              type="button"
              role="tab"
              aria-selected={active === i}
              className={`home-steps-dot${active === i ? " is-active" : ""}`}
              onClick={() => setActive(i)}
              aria-label={`Step ${step.n}: ${step.title}`}
            >
              <span className="home-steps-dot-fill" />
            </button>
          ))}
        </div>

        <ol className="home-steps-grid">
          {STEPS.map((step, i) => (
            <li
              key={step.n}
              className={`home-step${active === i ? " is-active" : ""}`}
              style={{ "--step-i": i }}
              onMouseEnter={() => setActive(i)}
            >
              <div className="home-step-visual">
                <img src={step.img} alt={step.alt} loading="lazy" />
              </div>
              <span className="home-step-n">{step.n}</span>
              <h3>{step.title}</h3>
              <p>{step.desc}</p>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}
